import React from "react";
import Spinner from "@src/components/Spinner";
import { ICuratorConversation } from "@src/types/curator";
import {
  formatConversationListTime,
  getClientDisplayName,
  getConversationId,
  getConversationStatus,
  getConversationTimestamp,
  getCuratorDisplayName,
  getLastMessagePreview,
} from "../Messages/conversationUtils";
import {
  CenteredNote,
  ConversationRow,
  RowBottomLine,
  RowCuratorName,
  RowParticipants,
  RowPreview,
  RowTime,
  RowTopLine,
  SidebarContainer,
  SidebarList,
  StatusPill,
} from "./AdminMessages.styles";

interface AdminConversationListProps {
  conversations: ICuratorConversation[];
  selectedConversationId: string | null;
  onSelectConversation: (conversationId: string) => void;
  isLoading: boolean;
  isError: boolean;
}

const AdminConversationList: React.FC<AdminConversationListProps> = ({
  conversations,
  selectedConversationId,
  onSelectConversation,
  isLoading,
  isError,
}) => (
  <SidebarContainer>
    <SidebarList>
      {isLoading && (
        <CenteredNote>
          <Spinner />
        </CenteredNote>
      )}
      {!isLoading && isError && (
        <CenteredNote>Could not load conversations.</CenteredNote>
      )}
      {!isLoading && !isError && conversations.length === 0 && (
        <CenteredNote>No conversations match these filters.</CenteredNote>
      )}
      {!isLoading &&
        !isError &&
        conversations.map((conversation) => {
          const conversationId = getConversationId(conversation);
          const status = getConversationStatus(conversation);

          return (
            <ConversationRow
              key={conversationId}
              $selected={selectedConversationId === conversationId}
              onClick={() => onSelectConversation(conversationId)}
            >
              <RowTopLine>
                <RowParticipants>
                  <RowCuratorName>
                    {getCuratorDisplayName(conversation)}
                  </RowCuratorName>
                  {" ↔ "}
                  {getClientDisplayName(conversation)}
                </RowParticipants>
                <RowTime>
                  {formatConversationListTime(
                    getConversationTimestamp(conversation)
                  )}
                </RowTime>
              </RowTopLine>
              <RowBottomLine>
                <StatusPill $status={status || "requested"}>
                  {(status || "requested").replace("_", " ")}
                </StatusPill>
                <RowPreview>
                  {getLastMessagePreview(conversation) || "No messages yet"}
                </RowPreview>
              </RowBottomLine>
            </ConversationRow>
          );
        })}
    </SidebarList>
  </SidebarContainer>
);

export default AdminConversationList;
